var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6665 19.9833L34.5999 15.3333L35.1665 9.18333L29.1499 7.81667L25.9999 2.5L20.3332 4.93333L14.6665 2.5L11.5165 7.81667L5.49988 9.16667L6.06654 15.3333L1.99988 19.9833L6.06654 24.6333L5.49988 30.8L11.5165 32.1667L14.6665 37.5L20.3332 35.05L25.9999 37.4833L29.1499 32.1667L35.1665 30.8L34.5999 24.65L38.6665 19.9833ZM32.0832 22.45L31.1499 23.5333L31.2832 24.95L31.5832 28.2L27.0165 29.2333L26.2832 30.4667L24.6332 33.2667L21.6665 31.9833L20.3332 31.4167L19.0165 31.9833L16.0499 33.2667L14.3999 30.4833L13.6665 29.25L9.09988 28.2167L9.39988 24.95L9.53321 23.5333L8.59988 22.45L6.44988 20L8.59988 17.5333L9.53321 16.45L9.38321 15.0167L9.08321 11.7833L13.6499 10.75L14.3832 9.51667L16.0332 6.71667L18.9999 8L20.3332 8.56667L21.6499 8L24.6165 6.71667L26.2665 9.51667L26.9999 10.75L31.5665 11.7833L31.2665 15.0333L31.1332 16.45L32.0665 17.5333L34.2165 19.9833L32.0832 22.45Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1499 22.9167L13.2832 19.0333L10.8165 21.5167L17.1499 27.8667L29.3832 15.6L26.9165 13.1167L17.1499 22.9167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/Sucess.f500b7a2bd64e983f671735fa2246a4d.svg";
export { ForwardRef as ReactComponent };